import { CatalogObject } from '../catalog-object';
import { Layer, LayerReference } from '../layer';
import { TooltipIcon } from '../tooltip-icon';

export enum ProjectType {
    COLLAGE_TYPE = 1,
    SCAN = 3,
}

export const DEMO_PROJECT_ID = 1;

/**
 * Checks if the project is the demo project
 * @param projectId project id to check
 */
export function isDemoProject(projectId: number): boolean {
    return projectId === DEMO_PROJECT_ID;
}

export interface RelatedJobSitesInfo {
    name: string;
    id: number;
    description?: string;
}

/**
 * This is the model of the project object
 */

export interface Project extends CatalogObject {
    // configuration
    creatorUserId: string;
    /**The hypothetical shape of the earth, coinciding with mean sea level and its imagined extension under (or over) land areas. */
    geoid: string | null;
    /**Defines some transformations to paint on a plane*/
    horizProjectionEPSG: string | null;
    /** List of project layers */
    layerTree: Layer[] | LayerReference[];
    projectType: ProjectType;
    thumbnail: string | null;
    minxWgs84: number;
    minyWgs84: number;
    minzWgs84: number;
    maxxWgs84: number;
    maxyWgs84: number;
    maxzWgs84: number;
    available: boolean;
    // this value is optional because it doesn't exist in Site
    uid?: string;
    owner?: string;
    icon?: TooltipIcon;
    sites?: RelatedJobSitesInfo[];
    sitesCount?: number;
}

// for using when creating a new project
export interface ProjectData {
    id?: number;
    name: string | null;
    description?: string | null;
    horizProjectionEPSG?: string | null;
    geoid?: string | null;
    projectType?: ProjectType;
    options?: any;
    available?: boolean;
    captureDate?: string;
}

export const PROJECT_VIEWER_TYPES: Map<ProjectType, string> = new Map([
    [ProjectType.COLLAGE_TYPE, '/viewer'],
    [ProjectType.SCAN, '/scan-viewer'],
]);

export enum ProjectMenuOptions {
    EDIT = 'EDIT',
    DELETE = 'DELETE',
    EDIT_PERMISSIONS = 'EDIT_PERMISSIONS',
    DEFAULT_VIEWER = 'DEFAULT_VIEWER',
    FILES_EXPLORER = 'FILES_EXPLORER',
    RELATED_SITES = 'RELATED_SITES',
}
